module.exports = __webpack_public_path__ + "static/media/fog.cb68d811.svg";